/**
 * Assessment Performance — entry point.
 *
 * Wraps the page in `ContentWrapper` (the same chrome
 * Population Health uses on this branch) and forwards the i18n title.
 *
 * TEMP: orphan after refactor/mui-v9-migration merges into development.
 * Replace the lazy import in routesByGroups/dashboard.js with the FSD
 * page (`@pages/assessment-performance`) and delete this directory.
 */
import { useSelector } from 'react-redux';
import ContentWrapper from 'components/Wrappers/ContentWrapper';
import AssessmentPerformancePage from './AssessmentPerformancePage';

const AssessmentPerformance = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);

  return (
    <ContentWrapper titleText={titles.assessmentPerformance}>
      <AssessmentPerformancePage />
    </ContentWrapper>
  );
};

export default AssessmentPerformance;
